export const ENTITY_PARAM_NAME = 'entity';
export const ENTITY_PARAM_TEMPLATE = `/:${ENTITY_PARAM_NAME}`;
